import { type ControllerParams } from '@wix/yoshi-flow-editor';

export function isOptimizationEnabled(params: ControllerParams) {
  const { environment } = params.flowAPI;

  return environment.isSSR;
}
